// apps/web/src/lib/product.ts
// Single source of truth for the product brand-name + version shown in the
// footer + landing tagline. audit-r3 F-021 (2026-05-24): was hardcoded in
// 2 places ("MACRO BRIEF v4.0" in ZoneFooter, "macro brief v4.0" in
// landing) with the GAS-era "MACRO BRIEF" name surviving the 2026-05-24
// rename to "Daily Brief".

export const PRODUCT_NAME    = 'Daily Brief';
export const PRODUCT_VERSION = 'v4.0';

// 2026-05-24 PM — browser-tab title per route. index.html ships a static
// <title>Daily Brief</title> as the boot title; this map drives the live update
// from App.tsx (useEffect on useLocation pathname). Unknown paths fall
// back to PRODUCT_NAME.
//
// A route MISSING from this map is invisible: it silently inherits the
// PRODUCT_NAME fallback, so its tab reads "Daily Brief" while the page shows a
// different h1 (reported 2026-07-15 for /oracle, added below). Adding a dashboard
// route ⇒ add its title here in the same commit.
//
// 2026-05-25 user fix — tab text MUST match the on-page dashboard heading
// (h1) verbatim. Prior values used URL-slug names ("Brief", "AMM",
// "Signal Tracker", "Ops Lab") which mismatched the user-facing
// landing-card / manifest-title strings ("Daily Brief", "Crypto",
// "Signal History", "Operations"). Each value here mirrors what the
// AD_<DASH>_MANIFEST.title resolves to (or the landing-card label for
// non-dashboard routes). / and /brief intentionally share "Daily Brief"
// because the landing IS the entry to the Daily Brief product.
const PAGE_TITLES: Record<string, string> = {
  '/':              PRODUCT_NAME,
  '/brief':         PRODUCT_NAME,
  '/crypto':        'Crypto',
  '/signal-history':'Signal History',
  '/operations':    'Operations',
  '/oracle':        'Data Oracle',   // mirrors AD_DATA_ORACLE_MANIFEST.title + the landing-card label
  '/sign-in':       'Sign in',
  '/__primitives':  'Primitives',
};

export function getPageTitle(pathname: string): string {
  return PAGE_TITLES[pathname] ?? PRODUCT_NAME;
}
